export enum CartDetailsSourceIdsEnum {
  RELOAD = 'RELOAD',
  OPTIONAL_MEMBER = 'OPTIONAL_MEMBER',
  OPTIONAL_INTERNET = 'OPTIONAL_INTERNET',
  REMOVE_SLOT = 'REMOVE_SLOT',
  ACCESSORY_ADD_NEW = 'ACCESSORY_ADD',
  ACCESSORY_CHANGE_QTY = 'ACCESSORY_CHANGE_QTY',
  CHANGE_PROCESS = 'CHANGE_PROCESS',
  REMOVE_DEVICE = 'REMOVE_DEVICE',
}
